module.exports = __webpack_public_path__ + "media/img/Scholarships2u-Logo-Dark-8376e184270201b53745188e96f64553.svg";